function ErrorPage({ error }) {
  return (
    <div className="flex min-h-[50vh] items-center justify-center px-4">
      <div className="max-w-md rounded-xl border border-brand-danger/30 bg-brand-danger/10 px-6 py-8 text-center">
        <h4 className="text-lg font-bold text-brand-danger">Invito non trovato</h4>
        <p className="mt-2 text-sm text-[var(--ba-muted)]">
          {error || 'Si è verificato un errore durante il caricamento della pagina.'}
        </p>
      </div>
    </div>
  );
}

export default ErrorPage;
